/* eslint-disable max-len */
import React, { useEffect } from 'react';
import { observer, inject } from 'mobx-react';
import styles from './productInfoShutter.scss';
import { IProductInfoStore } from '../../types';
import DetailsModal from '../detailsModal/detailsModal';
import { reaction } from 'mobx';
import classNames from 'classnames';
import IconArrowExtraSmallRight from '../icons/icon_arrow_extra_small_right';
import { Collapse } from 'react-collapse';
import TabNavigationHelper from '../../helpers/tabNavigationHelper';
import { decodeHTML } from '../../helpers/html-helper';
import ArrowDownShutters from '../icons/arrow_down_shutters';

const ProductInfoShutter = inject('productInfoStore')(
    observer(({ productInfoStore }: IProductInfoStore) => {
        useEffect(() => {
            reaction(() => productInfoStore.mainStore.variantStore.selectedBrickItem.masterArticleNo,
                (masterArticleNo) => {
                    if (masterArticleNo && productInfoStore.mainStore.variantStore.detailsModalOpen === true) {
                        productInfoStore.handleDetailsButtonClick(true,
                            productInfoStore.mainStore.variantStore.getArticleSetItem());
                    }
                });
            reaction(() => productInfoStore.mainStore.variantStore.detailsModalOpen,
                (value) => {
                    if (value === true) {
                        productInfoStore.handleDetailsButtonClick(value,
                            productInfoStore.mainStore.variantStore.getArticleSetItem());
                    }
                });

            reaction(() => productInfoStore.mainStore.mixedMediaStore.detailsModalOpen,
                (value) => {
                    if (value === true) {
                        productInfoStore.handleDetailsButtonClick(value,
                            productInfoStore.mainStore.mixedMediaStore.getArticleSetItem());
                        productInfoStore.mainStore.mixedMediaStore.setDetailsModalOpen(false);
                    }
                });

            productInfoStore.setShutterExpanded(true);
        }, []);

        const productInfoContentRef = React.useRef<HTMLDivElement>(null);
        const tabNavigation: TabNavigationHelper = TabNavigationHelper.instance;

        function handleExpand() {
            if (productInfoStore.productInfoExpanded) {
                productInfoStore.setProductInfoExpanded(false);
                productInfoContentRef.current?.parentElement?.style.
                    setProperty('max-height', '552px');
            }
            else {
                productInfoStore.setProductInfoExpanded(true);
                productInfoContentRef.current?.parentElement?.style.
                    setProperty('max-height', productInfoContentRef.current?.clientHeight + 'px');
            }

        }

        function handleShutterExpand() {
            productInfoStore.setShutterExpanded(!productInfoStore.shutterExpanded);
        }

        useEffect(() => {
            if (productInfoContentRef.current) {
                const productInfoContent = productInfoContentRef.current;
                if (productInfoContent.clientHeight > 552) {
                    productInfoStore.setProductInfoBig(true);
                } else {
                    productInfoStore.setProductInfoBig(false);
                }
            }
        }, [productInfoContentRef]);

        const gratisMlt = productInfoStore.mainStore.localization.generalL10n.gratis;

        return (
            <>
                <div className={styles.product_info_shutter}>
                    <div className={styles.shutter_header} ref={(el) => tabNavigation.setFocusAtt(el)}
                        onClick={handleShutterExpand}>
                        <div className={styles.shutter_title}>
                            {decodeHTML(productInfoStore.mainStore.localization.generalL10n.productInfo)}
                        </div>
                        <div className={classNames(styles.shutter_icon,
                            {
                                [styles.open]: productInfoStore.shutterExpanded,
                            })}
                        >
                            <ArrowDownShutters />
                        </div>
                    </div>
                    <Collapse theme={{ collapse: styles.collapse }}
                        isOpened={productInfoStore.shutterExpanded}>
                        <div className={classNames(styles.shutter_content)}>
                            {
                                productInfoStore.mainStore.dataStore.shutterModule.emotionalText &&
                                <div
                                    className={classNames(styles.emotionalText)}
                                    data-testid='product_info_emotionaltext'
                                >
                                    {productInfoStore.mainStore.dataStore.shutterModule.emotionalText}
                                </div>
                            }
                            <div className={styles.title}>
                                {decodeHTML(productInfoStore.mainStore.localization.generalL10n.briefDescription)}
                            </div>
                            <div className={classNames(styles.product_info_content, {
                                [styles.expanded]: productInfoStore.productInfoExpanded,
                            })} >
                                <div ref={productInfoContentRef}>
                                    <div className={styles.subtitle}>
                                        {decodeHTML(productInfoStore
                                            .mainStore
                                            .localization
                                            .generalL10n
                                            .articelSetConsistsOf)}
                                    </div>
                                    <div className={styles.shutter_items}
                                        ref={(el) => tabNavigation.toggleDisabledAtt(el, !productInfoStore.shutterExpanded)}>
                                        {productInfoStore.mainStore.dataStore.shutterModule.productInfo.
                                            description.sortedArticleSetItemDescriptions
                                            .map((item, index) => {

                                                const navigationKeyPath = productInfoStore.mainStore.dataStore.sortedBrickItems
                                                    .find((sortedBrick) => item.brickNo === sortedBrick.brickNo && item.selectedBrickItemNo === sortedBrick.brickItemNo)?.mainNavigationKeyPath

                                                return (
                                                    <div key={index} className={styles.shutter_item}>
                                                        <div className={styles.item_information}>
                                                            {item.isFreeInSet &&
                                                                <div className={styles.free_in_set}>
                                                                    {decodeHTML(gratisMlt)}
                                                                </div>}
                                                            <div className={styles.sales_designation_and_quantity}>
                                                                {item.includedQuantity}x {item.salesDesignation}
                                                            </div>
                                                            <div className={styles.item_color_and_size}>
                                                                {productInfoStore.getVariantLabel(item)}
                                                            </div>
                                                        </div>
                                                        <button className={styles.details_button}
                                                            data-testid='flexset-list-layer_0_details'
                                                            data-flexset-id={productInfoStore.mainStore.dataStore.orderModule.flexSetInfo.fsCode}
                                                            data-flexset-name={productInfoStore.mainStore.dataStore.orderModule.flexSetInfo.displayName}
                                                            data-flexset-module-layer_0-index={index}
                                                            data-flexset-module-layer_0-category={navigationKeyPath}
                                                            data-flexset-item-name={item.salesDesignation}
                                                            data-flexset-item-sku={productInfoStore.mainStore.getSalesArticleNo(
                                                                item.salesArticleVariantKey)}
                                                            onClick={() => {
                                                                productInfoStore.setItemOrigin('FlexSets-0-list');
                                                                productInfoStore.handleDetailsButtonClick(true, item);
                                                            }}
                                                            ref={(el) => tabNavigation.setFocusAtt(el)}>
                                                            {decodeHTML(
                                                                productInfoStore
                                                                    .mainStore
                                                                    .localization
                                                                    .generalL10n
                                                                    .details)}
                                                        </button>
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>
                                    <div className={styles.seasonal_note}>{decodeHTML(
                                        productInfoStore
                                            .mainStore
                                            .localization
                                            .generalL10n
                                            .seasonalNote)}</div>
                                </div>
                            </div>
                            {productInfoStore.productInfoBig && <div className={classNames(styles.expand_button_container, {
                                [styles.expanded]: productInfoStore.productInfoExpanded,
                            })}>
                                <div className={classNames(styles.expand_button, {
                                    [styles.open]: productInfoStore.productInfoExpanded,
                                })} onClick={handleExpand}
                                    ref={(el) => tabNavigation.setFocusAtt(el)}>
                                    {!productInfoStore.productInfoExpanded ?
                                        productInfoStore.mainStore.localization.generalL10n.more :
                                        productInfoStore.mainStore.localization.generalL10n.less
                                    }
                                    <IconArrowExtraSmallRight />
                                </div>
                            </div>}
                        </div>
                    </Collapse>
                </div >
                {
                    productInfoStore.mainStore &&
                    productInfoStore.articleSetItemDetail &&
                    productInfoStore.openedArticleSetItem &&
                    <DetailsModal productInfoStore={productInfoStore} />
                }
            </>
        );
    }));

export default ProductInfoShutter;
